module.exports = __webpack_public_path__ + "img/64.d61401f7.jpg";